<template>

  <div class="register">

    <div class="register__wrapper">

        <div class="register__rules">
          <h2 v-if="!submissions">Prijave</h2>
          <h2 v-if="submissions">Predaja rješenja</h2>

          <ul class="register__timetable">
            <li>
              <p class="register__timetable-head">do 16.10. <span>/</span> Najava natjecanja</p>
              <p class="register__timetable-description" v-if="!submissions">Trenutno smo u najavnoj fazi. Prijavi se putem formulara i podsjetit ćemo te kada ulazni podaci postanu dostupni i natjecanje službeno započne.</p>
            </li>
            <li>
              <p class="register__timetable-head">od 16.10. <span>/</span> Početak natjecanja</p>
              <p class="register__timetable-description" v-if="submissions">Natjecanje je službeno počelo! Rješenja možeš predati do 6.11. u 09:00.</p>
            </li>
            <li>
              <p class="register__timetable-head">do 6.11. u 09:00<span>/</span> Rok za predaju rješenja</p>
            </li>
            <li>
              <p class="register__timetable-head">6.11. u 11:00 <span>/</span> Proglašenje pobjednika</p>
              <p class="register__timetable-description">Dodjela nagrada na Fakultetu elektrotehnike i računarstva ili <a href="https://us06web.zoom.us/j/89261613558?pwd=dm92eTZ4eVdGa1dFNlI4OHFkZXNhQT09" target="_blank">online na Zoomu</a>.</p>
            </li>
          </ul>

        </div>
        <div class="register__form">

          <NewContestant v-if="!submissions" />
          <NewSubmission v-if="submissions" />

        </div>

    </div>

  </div>

</template>
<script>
import NewContestant from '@/components/NewContestant'
import NewSubmission from '@/components/NewSubmission'
export default {
  components: {
    NewContestant,
    NewSubmission
  },
  props: ['submissions']
}
</script>
